<ng-container>
    <progress id="file" [value]="progress" max="100" [class]="color" [style.width]="width" >  10% </progress>

</ng-container>